export default {
      id: "top-shape-mobile-usage",
      viewBox: "0 0 428 74",
      url: "../../assets/" + "sprite.svg#top-shape-mobile-usage",
      toString: function () {
        return this.url;
      }
    }